// Shared policy for panels that seek in response to the analysis cursor.
// Pointer hover remains opt-in and only affects paused playback. Arrow-key
// navigation is deliberate, so it always seeks even when hover sync is off or
// the destination panel is currently playing.
export function shouldSeekFromChartHover({
  fromKeyboard = false,
  hoverEnabled = false,
  playing = false,
} = {}) {
  return fromKeyboard || (hoverEnabled && !playing);
}
